import mapboxgl from 'mapbox-gl';
import { kml } from '@tmcw/togeojson';

const uploadDataUri =
  'data:image/svg+xml;base64,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';

export default class ShapeImportControl implements mapboxgl.IControl {
  container: HTMLElement;

  map: mapboxgl.Map;

  onAdd(map: mapboxgl.Map) {
    this.map = map;
    const id = new Date().getTime().toString();

    const uploader = document.createElement('input');
    uploader.setAttribute('type', 'file');
    uploader.setAttribute('id', id);
    uploader.classList.add('mapboxgl-ctrl-shape-import__uploader');
    uploader.addEventListener('change', () => {
      if (!uploader.files) {
        return;
      }
      const file = uploader.files[0];

      const reader = new FileReader();
      reader.onload = () => {
        this.handleKml(reader.result as string);
      };

      reader.readAsText(file);
    });

    const label = document.createElement('label');
    label.setAttribute('for', id);
    label.classList.add('mapboxgl-ctrl-shape-import__label');
    label.style.backgroundImage = `url('${uploadDataUri}')`;
    label.title = 'Upload KML';

    this.container = document.createElement('div');
    this.container.classList.add('mapboxgl-ctrl-group', 'mapboxgl-ctrl');
    this.container.appendChild(label);
    this.container.appendChild(uploader);
    return this.container;
  }

  onRemove() {
    const parent = this.container.parentNode;
    if (parent) {
      parent.removeChild(this.container);
    }
  }

  handleKml(kmlText: string) {
    const dom = new DOMParser().parseFromString(kmlText, 'text/xml');
    const featureCollection = kml(dom);
    this.map.fire('kml', { featureCollection });
  }
}
